/* GG MOD START - scroll_50_blog e blog_internal_click GA4 tracking */
(function() {
  // console.log('[blog-tracking] script avviato');
  // console.log('[blog-tracking] window._nobileArticle =', window._nobileArticle);
  // console.log('[blog-tracking] window.gtag al caricamento =', typeof window.gtag, '(può arrivare dopo, ok)');

  var art = window._nobileArticle;
  if (!art) { /* console.warn('[blog-tracking] STOP: _nobileArticle non definito'); */ return; }

  /* scroll_50_blog — una sola volta per pageview */
  var fired50 = false;
  function onScroll() {
    if (fired50) return;
    var docH = document.documentElement.scrollHeight - window.innerHeight;
    var pct  = docH > 0 ? Math.round((window.scrollY || window.pageYOffset) / docH * 100) : 0;
    // console.log('[blog-tracking] scroll', pct + '%', '(docH=' + docH + ')');
    if (docH <= 0) return;
    if (pct >= 50) {
      fired50 = true;
      window.removeEventListener('scroll', onScroll, { passive: true });
      // console.log('[blog-tracking] FIRE scroll_50_blog — window.gtag:', typeof window.gtag, art);
      if (!window.gtag) { /* console.warn('[blog-tracking] scroll_50_blog non inviato: gtag non disponibile'); */ return; }
      gtag('event', 'scroll_50_blog', {
        page_path:      art.pagePath,
        page_title:     art.title,
        article_handle: art.handle
      });
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  // console.log('[blog-tracking] listener scroll registrato');

  /* blog_internal_click */
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href]');
    // console.log('[blog-tracking] click — link trovato:', link ? link.href : 'nessuno');
    if (!link) return;
    var raw = link.getAttribute('href');
    if (!raw || raw === '#' || raw.charAt(0) === '#') {
      // console.log('[blog-tracking] click ignorato: ancora in-page');
      return;
    }
    if (link.hostname && link.hostname !== window.location.hostname) {
      // console.log('[blog-tracking] click ignorato: link esterno', link.hostname);
      return;
    }

    var path = link.pathname || '';
    var linkType = 'other';
    if      (path.indexOf('/products/')    !== -1) linkType = 'product';
    else if (path.indexOf('/collections/') !== -1) linkType = 'collection';
    else if (path.indexOf('/blogs/')       !== -1) linkType = 'blog';
    else if (path.indexOf('/pages/')       !== -1) linkType = 'page';

    // console.log('[blog-tracking] FIRE blog_internal_click — window.gtag:', typeof window.gtag, { link_url: link.href, link_type: linkType });
    if (!window.gtag) { /* console.warn('[blog-tracking] blog_internal_click non inviato: gtag non disponibile'); */ return; }
    gtag('event', 'blog_internal_click', {
      link_url:     link.href,
      link_text:    (link.innerText || link.textContent || '').trim().substring(0, 100),
      link_type:    linkType,
      from_article: art.handle
    });
  }, true);
  // console.log('[blog-tracking] listener click registrato');
})();
/* GG MOD END */
